'use client'

import Image from 'next/image'
import { H1, Body } from '@material-bank/mb3-components'
import { MbLogo } from '@material-bank/mtag-icons'
import { useTranslations } from '@material-bank/i18n'

export default function LandingPage() {
  const t = useTranslations('landingPage')

  return (
    <main className="flex min-h-svh flex-col items-center bg-stone-50 px-6 py-12 md:py-16 lg:py-20">
      <div className="flex w-full max-w-md flex-col items-center lg:max-w-lg">
        <MbLogo width={48} height={48} fill="#1C1C1C" />

        <Image
          src="https://mb-site-assets.global.ssl.fastly.net/mtag/landing-page.png"
          alt={t('imageAlt')}
          width={1087}
          height={725}
          priority
          className="mt-10 w-full"
        />

        <H1 className="mt-8 text-center text-2xl md:text-3xl">{t('title')}</H1>

        <Body className="mt-3 text-center text-muted-foreground">
          {t('subtitle')}
        </Body>
      </div>
    </main>
  )
}
